module.exports = __webpack_public_path__ + "img/bgPrincipal.b3a33deb.png";